module.exports = __webpack_public_path__ + "static/img/quyucang.a4010ce5.png";